//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserService from "@/api/userService";
import RealNameService from "@/api/realNameService";
import SignContractService from "@/api/signContractService";
import SysUtils from "@/utils/sysUtils";

export default {
  data() {
    return {
      theme: "yellow", // 主题
      mobile: "", // 手机号
      realNameStatus: 0, // 实名认证状态
      purchaseStatus: 0, // 购买合同状态
      logisticsStatus: 0, // 物流合同状态
      purchaseContractId: "", // 购买合同id
      logisticsContractId: "", // 物流合同id
      customerIdentNo: "", // 身份证号
      certType: "", // 证件类型
    };
  },
  computed: {
    userId: function () {
      return this.$route.query.userId; // 用户id
    },
    companyId: function () {
      return this.$route.query.companyId; // 公司编号
    },
  },
  mounted() {
    // 获取主题类型，如果没有，默认黄金主题
    const themeType = this.$route.query.themeType;
    let root = document.querySelector(":root");
    if (themeType == "black") {
      root.style.setProperty("--color", "#facd89");
      this.theme = "black";
    } else {
      root.style.setProperty("--color", "#fc581f");
      this.theme = "yellow";
    }

    // 将最终要跳转的地址缓存到本地
    let returnUrl = this.$route.query.returnUrl;
    if (returnUrl) {
      returnUrl = decodeURIComponent(decodeURIComponent(returnUrl));
      sessionStorage.setItem("RETURN_URL", JSON.stringify(returnUrl));
    }

    // 通过查询用户信息接口查询认证结果
    if (this.userId) {
      this.getUserInfo();
    } else {
      this.realNameStatus = "";
      this.purchaseStatus = "";
      this.logisticsStatus = "";
    }
  },
  methods: {
    handleNav() {
      // 如果全部状态都已经完成，回跳回原来的商城下单页面
      if (
        this.realNameStatus == 1 &&
        this.purchaseStatus == 1 &&
        this.logisticsStatus == 1
      ) {
        let returnUrl = sessionStorage.getItem("RETURN_URL");
        if (returnUrl) {
          returnUrl = JSON.parse(returnUrl);
          sessionStorage.removeItem("RETURN_URL");
          window.location.href = returnUrl;
        }
      }
    },
    // 查询用户信息
    getUserInfo() {
      UserService.getUserInfo(this.userId, this.companyId)
        .then((res) => {
          this.mobile = res.mobile;
          this.realNameStatus = res.idCardStatus;
          this.purchaseStatus = res.purchaseContractStatus;
          this.logisticsStatus = res.logisticsContractStatus;
          this.purchaseContractId = res.purchaseContractId;
          this.logisticsContractId = res.logisticsContractId;
          this.customerIdentNo = res.idNumber; // 身份证号
          this.certType = res.certType; // 证件类型

          this.handleNav();

          // 如果页面路径有status状态参数，说明是从法大大返回，如果状态为成功，因为本地接口不能及时更新，所以手动更新对应的状态
          if (
            SysUtils.getUrlKey("status") == 2 ||
            SysUtils.getUrlKey("result_code") == 3000
          ) {
            let currentStep = sessionStorage.getItem("CURRENT_STEP");
            if (currentStep == 1) {
              this.realNameStatus = 1;
            } else if (currentStep == 2) {
              this.purchaseStatus = 1;
            } else if (currentStep == 3) {
              this.logisticsStatus = 1;
            }

            // 当最后执行第二步或者第三步的时候，因为查询本地用户数据不能得到及时更新，所以这里需要再次对能否回跳做判断
            this.handleNav();
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    getRedirectUrl() {
      return (
        window.location.origin +
        window.location.pathname +
        "#/home?userId=" +
        this.userId +
        "&companyId=" +
        this.companyId
      );
    },
    // 点击实名认证
    clickRealName() {
      let data = {
        returnUrl: this.getRedirectUrl(),
        businessId: this.userId,
        merchantCode: this.companyId,
        mobile: this.mobile,
        customerIdentNo: this.customerIdentNo,
        certType: this.certType,
      };
      RealNameService.getVerifyAddress(data)
        .then((res) => {
          sessionStorage.setItem("CURRENT_STEP", 1); // 缓存当前操作步骤

          window.location.href = res.authPageUrl;
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    // 签署合同
    clickSign(type) {
      let postData = {
        userId: this.userId,
        merchantCode: this.companyId,
        type: type,
        returnUrl: this.getRedirectUrl(),
      };
      SignContractService.getSignAgreementUrl(postData)
        .then((res) => {
          // 缓存当前操作步骤
          let step = Number(type) + 1;
          sessionStorage.setItem("CURRENT_STEP", step);

          window.location.href = res;
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    // 点击查看合同
    viewAgreement(type) {
      let contractid = "";
      if (type == 1) {
        contractid = this.purchaseContractId;
      } else if (type == 2) {
        contractid = this.logisticsContractId;
      }
      if (contractid) {
        SignContractService.viewAgreement(contractid)
          .then((res) => {
            window.location.href = res;
          })
          .catch((err) => {
            this.$vux.toast.text(err.msg);
          });
      } else {
        this.$vux.toast.text("暂无合同数据");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/home.vue